/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocationGeo } from '../../models/location-geo';
import { LocationSettingsResponse } from '../../models/location-settings-response';

export interface UpdateLocationGeo$Params {
  location_id: string;
  
    /**
     * New geo position
     */
    body: LocationGeo
}

export function updateLocationGeo(http: HttpClient, rootUrl: string, params: UpdateLocationGeo$Params, context?: HttpContext): Observable<StrictHttpResponse<LocationSettingsResponse>> {
  const rb = new RequestBuilder(rootUrl, updateLocationGeo.PATH, 'put');
  if (params) {
    rb.path('location_id', params.location_id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LocationSettingsResponse>;
    })
  );
}

updateLocationGeo.PATH = '/locations/{location_id}/settings/geo';
